import { Spin } from '@osui/ui';
import React from 'react';
import Error from '@baidu/icloud-ui-error';
import './PageStatus.less';
import { jsx as _jsx } from "react/jsx-runtime";
export var renderError = function renderError(e) {
  return /*#__PURE__*/_jsx(Error, {
    error: e
  });
};
export function PageLoading(_ref) {
  var height = _ref.height;
  return /*#__PURE__*/_jsx("div", {
    className: 'icloud-ui-page-page-loading',
    style: {
      height: height
    },
    children: /*#__PURE__*/_jsx(Spin, {})
  });
}
PageLoading.displayName = "PageLoading";
//# sourceMappingURL=es/PageBoundary/PageStatus.js.map